module.exports = __webpack_public_path__ + "img/35ru.04133dfd.png";